// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3aLVl","main":"styles_main__1CxtJ","messageTemplateEditor":"styles_messageTemplateEditor__1bkhw","buttonBlock":"styles_buttonBlock__20ae5"};